import type { ComponentStyleConfig } from "@chakra-ui/react";

export const AccordionTheme: Partial<ComponentStyleConfig> = {
  baseStyle: {
    container: {
      borderTop: 0,
      p: 2,
      my: 6,
      _last: {
        borderBottom: 0,
      },
    },
    button: {
      _hover: {
        bg: "unset",
      },
    },
  },
};
